import { REL_ELEM, REL_LABL, REL_PLAN } from "./structure";

export default [
  {
    _id: "list1",
    name: "Pierwsza lista",
    type: "list",
    childRel: REL_ELEM,
    [REL_ELEM]: {
      key: "root:list",
      seq: "m",
    },
  },
  {
    _id: "list2",
    name: "Druga lista",
    type: "list",
    childRel: REL_ELEM,
    [REL_ELEM]: {
      key: "root:list",
      seq: "o",
    },
  },
  {
    _id: "today",
    name: "Dzisiaj",
    type: "period",
    childRel: REL_PLAN,
    [REL_ELEM]: {
      key: "root:period",
      seq: "m",
    },
  },
  {
    _id: "tomorrow",
    name: "Jutro",
    type: "period",
    childRel: REL_PLAN,
    [REL_ELEM]: {
      key: "root:period",
      seq: "o",
    },
  },
  {
    _id: "labelA",
    name: "Label A",
    type: "label",
    childRel: REL_LABL,
    [REL_ELEM]: {
      key: "root:label",
      seq: "m",
    },
  },
  {
    _id: "labelB",
    name: "Label B",
    type: "label",
    childRel: REL_LABL,
    [REL_ELEM]: {
      key: "root:label",
      seq: "o",
    },
  },
];
